(() => {
  class ImageWithText extends HTMLElement {
    constructor() {
      super();
      this.moreBtn = this.querySelector(".js-twi-weiterlesen-btn");
      this.hiddenContent = this.querySelector(".js-twi-hidden-content");
    }

    connectedCallback() {
      if (this.moreBtn) {
        this.moreBtn.addEventListener("click", () => {
          this.hiddenContent.style.maxHeight = `${this.hiddenContent.scrollHeight}px`;
          this.moreBtn.classList.add("opacity-0", "pointerevents-none");
        });
      }
    }
  }

  if (!customElements.get("text-with-image")) {
    customElements.define("text-with-image", ImageWithText);
  }
})();
